import axios from "axios";
export default {

  state: {
    newsCategory: null,
    loading:false,
    categories: [],
    subCategories: null,
    error:''
  },
  mutations: {
    setNewsCategory(state, payload) {
      state.newsCategory = payload;
    },
    setCategories(state, payload) {
      state.categories = payload;
    },
    setSubCategories(state, payload) {
      state.subCategories = payload;
    },
    error(state, data) {
      return state.error = data
  },
  
  loading(state) {
      return state.loading = false
  },
  categories(state, data) {
    return state.categories = data
},      
  },
  actions: {
    setNewsCategory: ({
      commit
    }, payload) => {
      commit('setNewsCategory', payload);
    },

    fetchData(context) {
      if(DEBUG) console.log('RUN FETCH DATA!!!!!!!!!!!!!!!')
      axios
          .get("http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_categories_with_shops")
          .then(response => {
              context.commit('loading')
              context.commit('categories', response.data)
  
          }).catch(error => {
              if(DEBUG) console.log(error.response.data.message || error.message)
              context.commit('error', error)
          });
  },

    updateCategory: ({
      commit
    }, payload) => {

      commit('setCategories', payload);
    },
    updateSubCategories: ({
      commit
    }, payload) => {
      commit('setSubCategories', payload);
    }
  },
  getters: {

    getNewsCategory(state) {
      return state.newsCategory;
    },
    getCategories(state) {
      return state.categories;
      
    },
    getSubCategories(state) {
      return state.subCategories;
    },

  }
}
